module.exports = __webpack_public_path__ + "img/user-profile-gray.ffdd372b.png";